module.exports = __webpack_public_path__ + "static/media/essentialism.4c92e3bf.png";